import { toast } from 'sonner';

// R3.1: conjunto cerrado de timeouts de auto-return HUMAN→IA (minutos).
// Default 60 cuando el centro nunca se configuró (R3.2), resuelto en lectura.
export const HUMAN_TIMEOUT_OPTIONS = [30, 60, 120, 240];

// R4: fábrica pura del handler del Select de timeout de auto-return.
// Se extrae del componente `WhatsAppDashboard` para poder unit-testear su
// comportamiento en runtime SIN montar el dashboard (montarlo con
// lucide-react + sonner + shadcn portals provoca OOM en jsdom). El handler
// resultante:
//   - ignora cambios si aún no hay stats cargadas (`hasStats` falso),
//   - coacciona el valor de Radix (string) a Number,
//   - valida contra el set cerrado antes de tocar el backend,
//   - PUT /whatsapp/config con { humanTimeoutMinutes: next },
//   - update optimista del state local vía `setStats`,
//   - toasts de éxito/fracaso,
//   - try/finally sobre `savingTimeout` (siempre se limpia).
export const makeHumanTimeoutHandler = ({ api, hasStats, setStats, setSavingTimeout, t }) =>
  async (value) => {
    if (!hasStats) return;
    const next = Number(value);
    if (!HUMAN_TIMEOUT_OPTIONS.includes(next)) return;
    setSavingTimeout(true);
    try {
      await api.put('/whatsapp/config', { humanTimeoutMinutes: next });
      setStats((s) => ({ ...s, whatsappHumanTimeoutMinutes: next }));
      toast.success(`Auto-return a IA configurado a ${next} minutos`);
    } catch {
      toast.error(t ? t('success.whatsapp.timeoutUpdateError') : 'No se pudo actualizar el timeout de auto-return');
    } finally {
      setSavingTimeout(false);
    }
  };
